"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var HotelRoomName = function HotelRoomName(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    name = _ref.name,
    originalName = _ref.originalName,
    area = _ref.area,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 8 : _ref$gap,
    _ref$headerFontSize = _ref.headerFontSize,
    headerFontSize = _ref$headerFontSize === void 0 ? 18 : _ref$headerFontSize,
    _ref$subtextFontSize = _ref.subtextFontSize,
    subtextFontSize = _ref$subtextFontSize === void 0 ? 14 : _ref$subtextFontSize;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    $gap: gap
  }, /*#__PURE__*/_react["default"].createElement(StyledHeader, {
    $fontSize: headerFontSize
  }, "".concat(name).concat(area ? " \xB7 ".concat(area).concat(t('hotel.room.area')) : '')), originalName && /*#__PURE__*/_react["default"].createElement(StyledSubtext, {
    $fontSize: subtextFontSize
  }, originalName));
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomName__Container",
  componentId: "sc-oa0qcx-0"
})(["display:flex;flex-direction:column;gap:", "px;"], function (_ref2) {
  var $gap = _ref2.$gap;
  return $gap;
});
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomName__StyledHeader",
  componentId: "sc-oa0qcx-1"
})(["color:var(--black);font-size:", "px;font-style:normal;font-weight:500;"], function (_ref3) {
  var $fontSize = _ref3.$fontSize;
  return $fontSize;
});
var StyledSubtext = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomName__StyledSubtext",
  componentId: "sc-oa0qcx-2"
})(["color:var(--black);font-size:", "px;font-style:normal;font-weight:400;"], function (_ref4) {
  var $fontSize = _ref4.$fontSize;
  return $fontSize;
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelRoomName);